var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-card", style: { background: _vm.backgroundColor } },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("div", { staticClass: "field-title" }, [
                          _c("span", { staticClass: "mark" }, [_vm._v("*")]),
                          _c("span", { style: { color: _vm.fontColor } }, [
                            _vm._v(
                              " 是否有取得或正在申請中之智財（專利、商標、著作權或其他） "
                            ),
                            _c("p", { staticClass: "en-text" }, [
                              _vm._v(
                                " Is there any IP obtained or being applying (patent, trademark, copy right, or others) "
                              ),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "field-radio" }, [
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.HasIP,
                                  expression: "HasIP",
                                },
                              ],
                              attrs: { type: "radio" },
                              domProps: {
                                value: true,
                                checked: _vm._q(_vm.HasIP, true),
                              },
                              on: {
                                change: function ($event) {
                                  _vm.HasIP = true
                                },
                              },
                            }),
                            _c("span", [_vm._v("是 (Yes)")]),
                          ]),
                          _c("label", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.HasIP,
                                  expression: "HasIP",
                                },
                              ],
                              attrs: { type: "radio" },
                              domProps: {
                                value: false,
                                checked: _vm._q(_vm.HasIP, false),
                              },
                              on: {
                                change: function ($event) {
                                  _vm.HasIP = false
                                },
                              },
                            }),
                            _c("span", [_vm._v("否 (No)")]),
                          ]),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "col-md-6" }),
                    _vm._l(_vm.intellectualProperty, function (item, index) {
                      return [
                        _c(
                          "div",
                          {
                            key: "IPCategory" + index + index,
                            staticClass: "col-md-6",
                          },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c("span", { staticClass: "mark" }, [
                                  _vm._v("*"),
                                ]),
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [
                                    _vm._v(" 請提供以下資訊 "),
                                    _c("p", { staticClass: "en-text" }, [
                                      _vm._v("Please select one option"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "field-value" },
                                [
                                  _c("ValidationProvider", {
                                    staticClass: "w-100",
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c(
                                                "el-select",
                                                {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    placeholder: "請選擇",
                                                  },
                                                  model: {
                                                    value: item.IPCategory,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "IPCategory",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.IPCategory",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.intellectualPropertyOptions,
                                                  function (opening) {
                                                    return _c(
                                                      "el-option",
                                                      {
                                                        key: opening.value,
                                                        attrs: {
                                                          label: opening.label,
                                                          value: opening.value,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              "text-overflow":
                                                                "ellipsis",
                                                              overflow:
                                                                "hidden",
                                                              "max-width":
                                                                "calc(100vw - 135px)",
                                                              "white-space":
                                                                "nowrap",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  opening.label
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              ),
                                              errors[0]
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "IPCategory" + index,
                            staticClass: "col-md-6",
                            staticStyle: { "margin-top": "30px" },
                          },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c("span", { staticClass: "mark" }, [
                                  _vm._v("*"),
                                ]),
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [
                                    _vm._v(" 智財字號 "),
                                    _c("span", { staticClass: "en-text" }, [
                                      _vm._v("IP code"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "field-value" },
                                [
                                  _c("ValidationProvider", {
                                    staticClass: "w-100",
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("el-input", {
                                                attrs: {
                                                  type: "text",
                                                  maxlength: "200",
                                                  placeholder: "請輸入",
                                                },
                                                model: {
                                                  value: item.IPCode,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "IPCode",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.IPCode",
                                                },
                                              }),
                                              errors[0]
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-danger",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(errors[0]) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "Description" + index,
                            staticClass: "col-md-12",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  staticClass: "w-100",
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 說明 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [_vm._v("Description")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("el-input", {
                                                  attrs: {
                                                    type: "textarea",
                                                    rows: 5,
                                                    maxlength: "200",
                                                    "show-word-limit": "",
                                                    placeholder:
                                                      item.IPCategory > -1
                                                        ? _vm.intellectualPropertyOptions.find(
                                                            (x) =>
                                                              x.value ===
                                                              item.IPCategory
                                                          ).placeholder
                                                        : "",
                                                  },
                                                  model: {
                                                    value: item.Description,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "Description",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.Description",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm.intellectualProperty.length > 1
                          ? _c(
                              "div",
                              {
                                key: "button" + index,
                                staticClass: "col-md-6",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn-sm del-btn",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.del(index)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("BUTTON.RESUME_DELETE")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c("div", {
                          key: "del" + index,
                          staticClass: "col-md-6",
                        }),
                      ]
                    }),
                  ],
                  2
                ),
                _c("div", { staticClass: "edit-btn-wrap" }, [
                  _vm.HasIP
                    ? _c(
                        "button",
                        {
                          staticClass: "btn-sm add-btn",
                          attrs: { type: "button" },
                          on: { click: _vm.add },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("BUTTON.RESUME_ADD")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "button",
                    {
                      staticClass: "put-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return handleSubmit(_vm.saveIP)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("BUTTON.RESUME_SAVE")) + " ")]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }